var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_114_8318)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5299 1.10015H3.77988C3.21322 1.13348 2.68822 1.28348 2.20488 1.55015C1.72155 1.81681 1.33822 2.19181 1.05488 2.67515C0.77155 3.15848 0.629883 3.68348 0.629883 4.25015V11.7501C0.629883 12.3168 0.77155 12.8418 1.05488 13.3251C1.33822 13.8085 1.72155 14.1835 2.20488 14.4501C2.68822 14.7168 3.19655 14.8668 3.72988 14.9001H12.5299C13.0632 14.8668 13.5716 14.7168 14.0549 14.4501C14.5382 14.1835 14.9216 13.8085 15.2049 13.3251C15.4882 12.8418 15.6299 12.3168 15.6299 11.7501V4.25015C15.6299 3.68348 15.4882 3.15848 15.2049 2.67515C14.9216 2.19181 14.5382 1.81681 14.0549 1.55015C13.5716 1.28348 13.0632 1.13348 12.5299 1.10015ZM3.77988 2.35015H12.5299C12.8966 2.38348 13.2382 2.50014 13.5549 2.70015C13.8716 2.90015 14.0966 3.18348 14.2299 3.55015L9.47988 8.35015C9.11322 8.71681 8.66322 8.90015 8.12988 8.90015C7.59655 8.90015 7.14655 8.71681 6.77988 8.35015L2.02988 3.55015C2.16322 3.18348 2.38822 2.90015 2.70488 2.70015C3.02155 2.50014 3.36322 2.40015 3.72988 2.40015L3.77988 2.35015ZM12.5299 13.6001H3.77988C3.24655 13.6001 2.79655 13.4251 2.42988 13.0751C2.06322 12.7251 1.87988 12.2835 1.87988 11.7501V5.20015L5.92988 9.20015C6.32988 9.60015 6.79655 9.87515 7.32988 10.0251C7.86322 10.1751 8.39655 10.1751 8.92988 10.0251C9.46322 9.87515 9.92988 9.60015 10.3299 9.20015L14.3799 5.20015V11.7501C14.3799 12.2835 14.1966 12.7251 13.8299 13.0751C13.4632 13.4251 13.0132 13.6001 12.4799 13.6001H12.5299Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_114_8318"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "matrix(1 0 0 -1 0.629883 15.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.43de13af2f42244a0c91e87f9aa24a53.svg";
export { ForwardRef as ReactComponent };